<mat-card *ngIf="item" class="contrast mat-card-inline-sm">
  <mat-card-content class="w-100" fxLayoutAlign="center start" fxLayout="column" fxFlex="100" fxLayoutGap="4px">
    <div class="w-100" fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
      <div fxLayoutAlign="start start" fxLayout="column" fxLayoutGap="5px">
        <strong>{{item?.customerName}}</strong><!-- <small *ngIf="getConnectType(item?.artifactKey)">{{ getConnectType(item.artifactKey) }}</small> -->
        <small>{{item?.customerReference}}</small>
      </div>
    </div>
    <!-- <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <div fxLayout="column" fxLayoutGap="2px">
          <div *ngIf="getConnectThemes(item.artifactKey) && getConnectThemes(item.artifactKey).length > 0" fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
            <div class="font-14">themes</div>
            <div>></div>
            <small>{{ getConnectThemes(item.artifactKey).join(", ") }}</small>
          </div>
        </div>
      </div>
    </div> -->
    <div class="w-100" fxFlex="100" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
      <div><small>created <span [matTooltip]="item?.sourceName" class="text-success">by </span><span class="text-info" matTooltip="{{ item?.dateAdded | date:'long' }}">{{ item?.dateAdded | date }}</span></small></div>
      <source-artifacts-menu class="card-icon" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [sourceArtifacts]="item?.baseIngredients"></source-artifacts-menu>
      <mat-icon *ngIf="isViewable(item.connectType)"
        class="card-icon link"
        [class.disable-link]="viewSituConnectId === item?.artifactId"
        [style.color]="getIconColor(item.connectType)" 
        [matTooltip]="getConnectTypeTooltip(item.connectType)"
        (click)="viewSituConnectId === item?.artifactId ? '' : select()">
          {{ getIconType(item.connectType) }}
      </mat-icon>
    </div>
  </mat-card-content>
</mat-card>